<template>
    <div>
        <base-header type="gradient-indigo" class="pb-6 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-8">
                    <h1 class="text-white pt-3 pb-4 px-3">เชื่อมต่อกับ Line Official Account</h1>
                </div>
                <div class="col-4 switch-status d-flex align-items-center justify-content-end pr-5">
                    <b-form-checkbox
                        v-model="form.status"
                        name="check-button"
                        :value="1"
                        :unchecked-value="0"
                        size="lg"
                        switch
                        @change="updateStatus($event)"
                    ></b-form-checkbox>
                </div>
            </div>
        </base-header>
        <BlockUI v-if="busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-lg-12 mb-3">
                    <card shadow no-body type="secondary">
                        <div 
                            slot="header" 
                            class="bg-white border-0 cursor-pointer"
                            :class="setting.first ? null : 'collapsed'"
                            :aria-expanded="setting.first ? 'true' : 'false'"
                            aria-controls="setting-first"
                            @click="setting.first = !setting.first"
                        >
                            <div class="row">
                                <div class="col-lg-11">
                                    <h3>
                                        <span class="pr-2 text-info">
                                            <i class="fas fa-angle-down" v-if="setting.first"></i>
                                            <i class="fas fa-angle-right" v-else></i>
                                        </span>
                                        ขั้นตอนที่ 1 : เชื่อม Messaging API
                                    </h3>                    
                                </div>
                                <div class="col-lg-1 d-flex justify-content-end" v-if="checkFormSuccess[STEP_FIRST]">
                                    <i class="fas fa-check-circle fa-2x text-success"></i>
                                </div>
                            </div>
                        </div>
                        <b-collapse id="setting-first" v-model="setting.first" class="mt-2">
                            <div class="card-body">
                                <TutorialLine :step="STEP_FIRST" />
                                <FormLineFirst 
                                    class="py-2" 
                                    :formFirst="formFirst"
                                    @submitForm="submitForm($event)"
                                />
                            </div>
                        </b-collapse>
                    </card>
                </div>
                <div class="col-lg-12 mb-3">
                    <card shadow no-body type="secondary">
                        <div 
                            slot="header" 
                            class="bg-white border-0 cursor-pointer"
                            :class="setting.second ? null : 'collapsed'"
                            :aria-expanded="setting.second ? 'true' : 'false'"
                            aria-controls="setting-second"
                            @click="setting.second = !setting.second"
                        >
                            <div class="row">
                                <div class="col-lg-11">
                                    <h3>
                                        <span class="pr-2 text-info">
                                            <i class="fas fa-angle-down" v-if="setting.second"></i>
                                            <i class="fas fa-angle-right" v-else></i>
                                        </span>
                                        ขั้นตอนที่ 2 : เชื่อม Login API Access
                                    </h3>
                                </div>
                                <div class="col-lg-1 d-flex justify-content-end" v-if="checkFormSuccess[STEP_SECOND]">
                                    <i class="fas fa-check-circle fa-2x text-success"></i>
                                </div>
                            </div>
                        </div>
                        <b-collapse id="setting-second" v-model="setting.second" class="mt-2">
                            <div class="card-body">
                                <TutorialLine :step="STEP_SECOND" />
                                <FormLineSecond 
                                    class="py-2"
                                    :formSecond="formSecond"
                                    @submitForm="submitForm($event)"
                                />
                            </div>
                        </b-collapse>
                    </card>
                </div>
            </div>
        </div>
        <ModalAlert
            :alert="alert"
        />
    </div>
</template>

<script>
import TutorialLine from '../../components/custom/setting/TutorialLine';
import FormLineFirst from '../../components/custom/setting/FormLineFirst';
import FormLineSecond from '../../components/custom/setting/FormLineSecond';
import ModalAlert from '@/components/Modals/ModalAlert'
import { STEP_FIRST , STEP_SECOND , STATUS_ENABLE } from '@/plugins/index'
import { registerLineApp , getLineAppByShop , updateStatusLineApp } from '../../axios/line';
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";


export default {
    data: () => ({
        busy: false,
        setting: {
            first: false,
            second: false
        },
        checkFormSuccess:{
            FIRST: false,
            SECOND: false
        },
        form:{  
            status: false,
            id: null
        },
        formFirst:{
            messagingChannelId: '',
            messagingChannelSecret: '',
            messagingChannelAccessToken: '',
            webhookUrl: '',
            isLoading: false
        },
        formSecond:{
            loginChannelId: '',
            loginChannelSecret: '',
            isLoading: false
        }, 
        STEP_FIRST,
        STEP_SECOND,
        alert:{
            show : false,
            icon : "",
            emphasize : "",
        },
    }),
    components: { 
        TutorialLine, 
        FormLineFirst,
        FormLineSecond,
        ModalAlert
    },
    mounted(){
        this.getSettingShop();
    },
    methods:{
        updateStatus($event){
            updateStatusLineApp(
                this.form.id ,
                $event
            ).then( res => {
                if(res){
                    showSuccessModal("อัพเดทสถานะสำเร็จ")
                }
            });
        },
        getSettingShop(){
            this.busy = true;
            getLineAppByShop().then( response => {
                if( response === null ){
                    this.busy = false;
                    return false;
                }

                this.formFirst.messagingChannelId = response.messaging_channel_id
                this.formFirst.messagingChannelSecret = response.messaging_channel_secret
                this.formFirst.messagingChannelAccessToken = response.messaging_channel_access_token
                this.formFirst.webhookUrl = this.genWebhook(response.shop_id);
                this.formSecond.loginChannelId = response.login_channel_id
                this.formSecond.loginChannelSecret = response.login_channel_secret

                this.form.id = response.id;
                this.form.status = response.status;

                this.checkForm(STEP_FIRST)
                this.checkForm(STEP_SECOND)
                
                this.busy = false;
            }).catch(error => {
                showErrorModal( error )
                this.busy = false;
            })
        }, 
        submitForm( step ){
            
            this.setIsLoading( step , true )

            registerLineApp(step , { ...this.formFirst, ...this.formSecond } ).then( response => {
                let msg = null;

                this.setIsLoading( step , false )

                if( response.status_register === STATUS_ENABLE ){
                    msg = 'เชื่อมต่อ LINE Official Account เรียบร้อยแล้ว'
                }else{
                    msg = 'บันทึกข้อมูลสำเร็จ'
                }

                this.formFirst.webhookUrl = this.genWebhook(response.shop_id);

                this.openModalAlert(
                    '<i class="fas fa-check-circle fa-3x text-success"></i>',
                    `<span>${msg}</span>`
                );

                this.getSettingShop();

            }).catch(error => {
                this.setIsLoading( step , false )
                showErrorModal( error )
            })
        },
        setIsLoading(step , status){
            if( step === STEP_FIRST){
                this.formFirst.isLoading = status;
            }else{
                this.formSecond.isLoading = status;
            }
        },
        checkForm(step){
            let res = false;
            let data = {};
            if(step == STEP_FIRST){
                Object.keys(this.formFirst).forEach(key => {
                    if( [
                            'messagingChannelId',
                            'messagingChannelSecret',
                            'messagingChannelAccessToken'
                        ].includes(key)
                    ){
                        data[key] = this.formFirst[key]
                    }
                });
            }else if(step == STEP_SECOND){
                Object.keys(this.formSecond).forEach(key => {
                    if( [
                            'loginChannelId',
                            'loginChannelSecret'
                        ].includes(key)
                    ){
                        data[key] = this.formSecond[key]
                    }
                });
            }

            res = Object.values(data).every(val => (val != '' || val.length > 0));

            this.checkFormSuccess[step] = res;

            return res;
        },
        openModalAlert(icon , emphasize){
            this.alert.show = true;
            this.alert.icon = icon; //'<i class="fas fa-exclamation-triangle text-yellow fa-5x"></i>'
            this.alert.emphasize = emphasize; //'<span>ขออภัย! พบข้อผิดพลาดในการสแกน QR Code <br> กรุณาลองใหม่อีกครั้ง</span>'
        },
        genWebhook(shopId){
            return `${window.location.origin}/shopx-backend/public/line/chat/webhook/${shopId}`
        }
    }
}
</script>
